import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import DialogProps from './DialogProps'
import KendoDialogAction from './KendoDialogAction'

import Animation from './Animation'
import Messages from './Messages'
import Modal from './Modal'

export default {
    props: DialogProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        Animation,
        Messages,
        Modal
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoDialog(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoDialog()
        },
        _resolveChildren() {
            this.resolveChildren('actions', KendoDialogAction.name)
        },
        toggleClasses () {

        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dialog-vue-wrapper/src/KendoDialog/KendoDialogMixin.js